// ───────────────────────────────────────────────────────────────
// src/hooks/useProfesorPerfil.ts
// Hook global: recupera TODO el perfil del profesor (datos + ficha)
// ───────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";
import api from "../api/axios";

export interface PerfilProfesor {
  usuario: any; // datos personales (nombreCompleto, teléfono, …)
  basicos: any; // horasSemanales, comentarios
  idiomas: any[];
  tipos: any[];
  formatos: any[];
  centros: any[];
  asignaturas: any[];
  disponibilidad: any[];
  vacaciones: any[];
}

export function useProfesorPerfil(id?: number) {
  const [data, setData] = useState<PerfilProfesor | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    if (!id) return;
    let cancel = false;

    (async () => {
      try {
        const year = new Date().getFullYear();

        const [
          usuario,
          basicos,
          idiomas,
          tipos,
          formatos,
          centros,
          asignaturas,
          disponibilidad,
          vacaciones,
        ] = await Promise.all([
          api.get(`/usuarios/${id}`).then((r) => r.data),
          api.get(`/profesores/${id}/datos`).then((r) => r.data),
          api.get(`/profesores/${id}/idiomas`).then((r) => r.data),
          api.get(`/profesores/${id}/tipos`).then((r) => r.data),
          api.get(`/profesores/${id}/formatos`).then((r) => r.data),
          api.get(`/profesores/${id}/centros`).then((r) => r.data),
          api.get(`/profesores/${id}/asignaturas`).then((r) => r.data),
          api.get(`/disponibilidad-profesor?profesor=${id}`).then((r) => r.data),
          api.get(`/vacaciones?profesor=${id}&year=${year}`).then((r) => r.data),
        ]);

        if (!cancel) {
          setData({
            usuario,
            basicos,
            idiomas,
            tipos,
            formatos,
            centros,
            asignaturas,
            disponibilidad,
            vacaciones,
          });
        }
      } catch (err) {
        if (!cancel) setError(err);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();

    return () => {
      cancel = true;
    };
  }, [id]);

  return { data, loading, error };
}
